module.exports = __webpack_public_path__ + "img/wintergarten.49017542.jpg";